import React, { Fragment, useState } from "react";
import { Image, Transformation } from "cloudinary-react";
import ModalVideo from "../modal/ModalVideo";
import IconHomebeatLogo from "../icons/IconHomebeatLogo";
import IconPlay from "../icons/IconPlay";
import IconCheckmark from "../icons/IconCheckmark";
import AutoPilotIllustration from "./illustrations/AutoPilotIllustration";
import StayValuableIllustration from "./illustrations/StayValuableIllustration";
import YourBrandIllustratrion from "./illustrations/YourBrandIllustration";
import ShowMeTheCompsIllustration from "./illustrations/ShowMeTheCompsIllustration";
import MarketTrendsIllustration from "./illustrations/MarketTrendsIllustration";
import LivingCmaIllustration from "./illustrations/LivingCmaIllustration";
import {
  Container,
  Wrapper,
  Hero,
  HeroLogo,
  HeroTitle,
  HeroDescription,
  AvailabilityDisclaimer,
  Actions,
  Action,
  Preview,
  ImageLayout,
  SectionTitle,
  SectionSubTitle,
  SectionIcon,
  SectionDescription,
  SectionNumber,
  Grid,
  Cell,
  Card,
  Button,
  ButtonTry,
  Working,
  Clients,
  Client,
  ClientDetails,
  ClientIcon,
  GettingStarted,
  GettingStartedFooter,
  GettingStartedSubTitle,
  GettingStartedList,
  GettingStartedListItem
} from "./styled/homebeat-marketing-page";

function HomebeatMarketingPage() {
  const [isShowingVideo, setIsShowingVideo] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const homebeatUrl = "/pricing";
  return (
    <Fragment>
      <Container>
        <Hero>
          <Wrapper>
            <HeroLogo>
              <IconHomebeatLogo />
            </HeroLogo>
            <HeroTitle>Set It and Forget It.</HeroTitle>
            <HeroDescription>
              Schedule live automated CMAs that keep you top-of-mind with
              homeowners.
            </HeroDescription>
            <Actions>
              <Action>
                <ButtonTry app="cma" href={homebeatUrl}>
                  Try for free*
                </ButtonTry>
              </Action>
              <Action>
                <Button
                  variant="secondary"
                  app="suite"
                  onClick={() => setIsShowingVideo(true)}>
                  <IconPlay />
                  Watch Video
                </Button>
              </Action>
            </Actions>
            <AvailabilityDisclaimer>
              * Only available in select markets
            </AvailabilityDisclaimer>
          </Wrapper>
        </Hero>
        <Preview>
          <Wrapper>
            <ImageLayout imageLoaded={imageLoaded}>
              <Image
                alt="A laptop computer and smartphone display a list of houses around a subject property, showcasing Homebeat."
                cloudName="wr-studios"
                publicId="cas/marketing/homebeat/hero-homebeat.png"
                onLoad={() => setImageLoaded(true)}>
                <Transformation fetchFormat="auto" dpr="auto" />
              </Image>
            </ImageLayout>
          </Wrapper>
        </Preview>
        <Working>
          <Wrapper>
            <SectionTitle>
              Homebeat is working, even when you're not.
            </SectionTitle>
            <Grid>
              <Cell>
                <Card>
                  <SectionNumber>1</SectionNumber>
                  <SectionIcon>
                    <AutoPilotIllustration />
                  </SectionIcon>
                  <SectionSubTitle>Auto-pilot</SectionSubTitle>
                  <SectionDescription>
                    Automatically send your clients a comparison of their home
                    to others on the market. Choose monthly all the way up to
                    annually.
                  </SectionDescription>
                </Card>
              </Cell>
              <Cell>
                <Card>
                  <SectionNumber>2</SectionNumber>
                  <SectionIcon>
                    <StayValuableIllustration />
                  </SectionIcon>
                  <SectionSubTitle>Stay Valuable</SectionSubTitle>
                  <SectionDescription>
                    Comparing homes is just the beginning. When your clients are
                    ready for a complete home valuation, they can contact you
                    for a full CMA report.
                  </SectionDescription>
                </Card>
              </Cell>
              <Cell>
                <Card>
                  <SectionNumber>3</SectionNumber>
                  <SectionIcon>
                    <YourBrandIllustratrion />
                  </SectionIcon>
                  <SectionSubTitle>Your branding</SectionSubTitle>
                  <SectionDescription>
                    You're always by their side to answer questions about the
                    value of their home and the market around them.
                  </SectionDescription>
                </Card>
              </Cell>
            </Grid>
          </Wrapper>
        </Working>
        <Clients>
          <Wrapper>
            <SectionTitle>Your clients will love their Homebeat.</SectionTitle>
            <Client>
              <ClientDetails>
                <SectionSubTitle>"Show me the comps"</SectionSubTitle>
                <SectionDescription>
                  Let them compare their home to actual comparables (not AVMs)
                </SectionDescription>
              </ClientDetails>
              <ClientIcon>
                <ShowMeTheCompsIllustration />
              </ClientIcon>
            </Client>
            <Client>
              <ClientIcon>
                <MarketTrendsIllustration />
              </ClientIcon>
              <ClientDetails>
                <SectionSubTitle>Market trends</SectionSubTitle>
                <SectionDescription>
                  See how the market is trending in their zip code.
                </SectionDescription>
              </ClientDetails>
            </Client>
            <Client>
              <ClientDetails>
                <SectionSubTitle>It's a living CMA</SectionSubTitle>
                <SectionDescription>
                  This online CMA is always current and will show the latest
                  market data everytime they check the link.
                </SectionDescription>
              </ClientDetails>
              <ClientIcon>
                <LivingCmaIllustration />
              </ClientIcon>
            </Client>
          </Wrapper>
        </Clients>
        <GettingStarted>
          <Wrapper>
            <SectionTitle>It's easy to get started.</SectionTitle>
            <Grid>
              <Cell>
                <Card>
                  <SectionNumber>1</SectionNumber>
                  <SectionSubTitle>Pick your client</SectionSubTitle>
                  <SectionDescription>
                    All you need is your client's email and home address.
                  </SectionDescription>
                </Card>
              </Cell>
              <Cell>
                <Card>
                  <SectionNumber>2</SectionNumber>
                  <SectionSubTitle>Schedule frequency</SectionSubTitle>
                  <SectionDescription>
                    You pick how often to touch base: Monthly all the way up to
                    Annually
                  </SectionDescription>
                </Card>
              </Cell>
              <Cell>
                <Card>
                  <SectionNumber>3</SectionNumber>
                  <SectionSubTitle>Send and automate</SectionSubTitle>
                  <SectionDescription>
                    They'll get their first Homebeat right away and then
                    automatically in the future.
                  </SectionDescription>
                </Card>
              </Cell>
            </Grid>
            <GettingStartedFooter>
              <GettingStartedSubTitle>
                Send your contacts a Homebeat today
              </GettingStartedSubTitle>
              <ButtonTry variant="primary" as="a" app="cma" href={homebeatUrl}>
                Try for free
              </ButtonTry>
              <GettingStartedList>
                <GettingStartedListItem>
                  <IconCheckmark />
                  Free 14-day trial
                </GettingStartedListItem>
              </GettingStartedList>
            </GettingStartedFooter>
          </Wrapper>
        </GettingStarted>
      </Container>
      {isShowingVideo && (
        <ModalVideo
          wistiaId="fun1dhrqqd"
          onClose={() => setIsShowingVideo(false)}
        />
      )}
    </Fragment>
  );
}

export default HomebeatMarketingPage;
